<app-algolia-instantsearch [config]="instantSearchConfig">
    <app-algolia-configure *ngIf="searchParameters$ | async as searchParameters"
                           [searchParameters]="searchParameters"
    ></app-algolia-configure>

    <app-dealers-hits></app-dealers-hits>
</app-algolia-instantsearch>
